import { z } from "zod";

const OPTIONAL_NUMBER = /^\d+([.,]\d+)?$/;

function optionalNumber(message: string, max: number) {
	return z
		.string()
		.trim()
		.refine((value) => value === "" || OPTIONAL_NUMBER.test(value), {
			message,
		})
		.refine((value) => value === "" || Number(value.replace(",", ".")) <= max, {
			message: `Informe um valor até ${max}`,
		});
}

export const daySchema = z
	.object({
		status: z.enum(["present", "absent", "medical_leave", "day_off"]),
		note: z
			.string()
			.trim()
			.max(1000, { message: "A observação deve ter até 1000 caracteres" }),
		overtimeMinutesOverride: optionalNumber(
			"Informe os minutos como número inteiro",
			1440,
		).refine((value) => value === "" || Number.isInteger(Number(value)), {
			message: "Informe os minutos como número inteiro",
		}),
		overtimePctOverride: optionalNumber("Informe o percentual", 999.99),
		editNote: z
			.string()
			.trim()
			.max(1000, { message: "A justificativa deve ter até 1000 caracteres" }),
		requiresJustification: z.boolean(),
	})
	.superRefine((data, ctx) => {
		if (data.requiresJustification && !data.editNote) {
			ctx.addIssue({
				code: "custom",
				message: "Descreva a justificativa da alteração",
				path: ["editNote"],
			});
		}
	});

export type DayFormValues = z.infer<typeof daySchema>;

export function parseOptionalNumber(value: string): number | null {
	const trimmed = value.trim();
	if (trimmed === "") return null;
	return Number(trimmed.replace(",", "."));
}

export function formatOptionalNumber(value: number | null): string {
	return value == null ? "" : String(value);
}
